"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBackLink = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledBackLink = styled_components_1.default.a(function (_a) {
    var _b = _a.theme, space = _b.space, text = _b.text, textLink = _b.textLink, mediaQueries = _b.mediaQueries, focusRing = _b.focusRing;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-decoration: underline;\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:focus {\n      ", "\n    }\n\n    ", " {\n      font-size: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    text-decoration: underline;\n    display: inline-flex;\n    align-items: center;\n    gap: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:focus {\n      ", "\n    }\n\n    ", " {\n      font-size: ", ";\n    }\n  "])), text.fontFamily, text.lineHeight, text.fontWeight, text.p.fontSize[0], textLink.fontWeight, textLink.color, space[2], textLink.hover, focusRing, mediaQueries.smallAndUp, text.p.fontSize[1]);
});
var templateObject_1;
